import React from 'react';
import {Text, View} from 'react-native';
import {Dropdown} from 'react-native-element-dropdown';
import {tID} from '../../../utils/TestIdHelper';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';

const DropdownSelect = ({
  style = {},
  titleStyle = {},
  data,
  onChangeMethod,
  value,
  label,
  testID,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View testID={tID('DropdownSelect-View-Main')} style={style}>
      <Text
        testID={tID('DropdownSelect-Text-Title')}
        style={[styles.inputTitleStyle, titleStyle]}>
        {label}
      </Text>
      <Dropdown
        testID={testID || tID('DropdownSelect-Dropdown-1')}
        style={[styles.dropdown]}
        placeholderStyle={styles.placeholderStyle}
        selectedTextStyle={styles.selectedTextStyle}
        inputSearchStyle={styles.inputSearchStyle}
        containerStyle={styles.dropdownContainer}
        itemTextStyle={styles.itemText}
        activeColor={colors.accentSubtle}
        iconStyle={styles.iconStyle}
        data={data}
        search
        maxHeight={300}
        labelField="label"
        valueField="value"
        placeholder={'Select...'}
        searchPlaceholder="Search..."
        value={value}
        onChange={item => {
          onChangeMethod(item.value);
        }}
      />
    </View>
  );
};

export default DropdownSelect;
